//
//
//
//
//
//
//
//
//

import PendenciaNegociacao from './PendenciaNegociacao';
import Apuracao from './Apuracao';
import PendenciaApuracao from './PendenciaApuracao';
import ListarEvidencia from './ListarEvidencia';

export default {
  name: 'Detalhes',
  components: {
    ListarEvidencia,
    PendenciaApuracao,
    PendenciaNegociacao,
  },
  props: {
    item: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dialog: false,
      pendencia: null,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.preencherPendencias();
      } else {
        this.$emit('Detalhes_close');
      }
    },
  },
  methods: {
    preencherPendencias() {
      const id = this.item.id;

      this.dashboardApuracaoResources.apuracao({ id })
        .then((response) => {
          this.pendencia = new Apuracao(this.$t('title.negociacao'), this.item.id, this.item.idAcordo, response.data);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/Detalhes.vue?vue&type=script&lang=js&